module.exports = __webpack_public_path__ + "img/salmon.0b0ef355.jpg";